import { info_tab, preview_tab } from '../../../../../../views/contract/template';

export default {
  title: 'Plantilla de contrato',
  tabs: {
    [info_tab]: 'Info',
    [preview_tab]: 'Vista previa',
  },
  sections: {
    subscription: 'Suscripción',
    setup_cost: 'Coste de configuración',
    preview: 'Vista previa',
  },
  form: {
    has_trial: {
      label: 'Añadir días de prueba',
    },
    trial_days: {
      label: 'Días de prueba gratuitos',
      placeholder: '7',
      validation: {
        required: 'Los días de prueba son obligatorios',
        min: '{{value}} es el valor mínimo para días de prueba',
      },
    },
  },
  buttons: {
    apply: 'Aplicar cambios',
    download: 'Descargar',
    apply_changes: 'Aplicar cambios',
  },
  files: {
    contract: '{{provider}}-contract-template-{{company}}.pdf',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar la vista previa',
  },
};
